import { z } from 'zod';

export const dcRoleSchema = z.object({
    instance_id: z.string(),
    id: z.string(),
    value: z.string(),
});

export type DcRole = z.infer<typeof dcRoleSchema>;

/** GET /secure-admin/doc-cirrus/roles -> { data: DcRole[] }. */
export const dcRolesResponseSchema = z.object({
    data: z.array(dcRoleSchema),
});
